import React from 'react';
import { Box, Card, CardHeader, CardContent, Stack, Typography, Checkbox } from '@mui/material';
import { SmallFormTextField } from '../../../../../../components/small-fields/SmallFormTextField';
import { useSelector } from 'react-redux';

export const SchoolInfoForm = ({ formik }) => {
  const { seasonYear } = useSelector(state => state.app);
  const fields = [
    { label: 'Nazwa', name: 'school_name', placeholder: 'nazwa' },
    { label: 'Adres', name: 'school_street_address', placeholder: 'adres', multiline: true },
    { label: 'Województwo', name: 'school_province', placeholder: 'województwo' },
    { label: 'Gmina', name: 'school_county', placeholder: 'gmina' },
    { label: 'Powiat', name: 'school_commune', placeholder: 'powiat' },
    { label: 'Miejscowość', name: 'school_city', placeholder: 'miejscowość' },
    { label: 'Kod pocztowy', name: 'school_postal_code', placeholder: 'kod pocztowy' },
    { label: 'NIP', name: 'school_nip', placeholder: 'nip szkoły' }
  ];

  return (
    <Stack direction="row" justifyContent="center" m={2}>
      <Card sx={{ width: '100%' }}>
        <CardHeader title="Dane szkoły" sx={{ mt: -1 }} />
        <CardContent>
          <Box
            display="flex"
            flexWrap="wrap"
            gap={2}
            mt={1}
          >
            {fields.map(({ label, name, placeholder, multiline }) => (
              <Box key={name} display="flex" alignItems="center" gap={1} sx={{ minWidth: '300px', flex: '1 1 300px' }}>
                <Typography variant="subtitle2">{label}</Typography>
                <SmallFormTextField
                  error={formik.errors[name] && formik.touched[name]}
                  name={name}
                  placeholder={placeholder}
                  value={formik.values[name]}
                  onChange={formik.handleChange}
                  helperText={formik.errors[name]}
                  fullWidth
                  multiline={multiline}
                />
              </Box>
            ))}

            {seasonYear < 2026 && <Box display="flex" alignItems="center" gap={1} sx={{ minWidth: '300px', flex: '1 1 300px' }}>
              <Typography variant="subtitle2">Bez dyrektora</Typography>
              <Checkbox
                id="without_director"
                name="without_director"
                checked={formik.values.without_director}
                onChange={formik.handleChange}
              />
            </Box>}
          </Box>
        </CardContent>
      </Card>
    </Stack>
  );
};
